<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="正在上传"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width='550px'
      :close-on-click-modal='false'
      :show-close="true"
      :before-close='closeDialog'>
      <el-form
        v-if='isShowForm'
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px">
        <el-form-item label="所属项目" prop='projectId' v-if='isNeedProject'>
          <el-select v-model="ruleForm.projectId" placeholder="请选择项目" filterable>
            <el-option v-for="(item,index) in projectList" :label="item.projectName" :value="item.projectId" :key='index'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导入数据" prop='fileName'>
          <div class="fileName">
            <a :href="tempUrl"
              class="downloadText"
              target="_self" >下载数据模板</a>&nbsp;
            <el-upload
              ref="upload"
              :headers="headInfo"
              :action="formatImportUrl"
              :data="getParam()"
              accept='.xls,.xlsx'
              :on-success="successFile"
              :before-upload='beforeUpload'
              :on-error='fileError'
              :on-change='uploadChange'
              :file-list="fileList"
              :auto-upload='!isNeedProject'
              :show-file-list='false'>
              <el-button type="text" class="uploading">
                {{ ruleForm.fileName ? "重新上传" : "上传数据" }}
              </el-button>
            </el-upload>
          </div>
          <p>{{ruleForm.fileName}}</p>
        </el-form-item>
        <div class="warning">
          <i class="el-icon-warning"></i>
          <span>请先下载数据模板，根据模板表填入数据后再上传</span>
        </div>
        <el-form-item v-if='isNeedProject'>
          <el-button type="primary" @click="submit" :disabled='fullscreenLoading'>保存</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
      <div v-else>
        <p class="resultText">
          已成功导入数据{{resData.success}}条,导入失败{{resData.error}}条
        </p>
        <el-table
          ref="resultTable"
          class="global-table" stripe
          max-height="600"
          :data="resultList">
          <el-table-column label="数据位置" prop="position" min-width="100" align='center' showOverflowTooltip></el-table-column>
          <el-table-column label="失败原因" prop="error" min-width="100" align='center' showOverflowTooltip></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImportData',
  props: {
    importUrl: {
      type: String,
      default: ''
    },
    isNeedProject: {
      type: Boolean,
      default: false
    },
    isShowImport: {
      type: Boolean,
      default: false
    },
    tempUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false,
      fullscreenLoading: false,
      title: '导入',
      isShowForm: true,
      ruleForm: {
        projectId: '',
        fileName: ''
      },

      rules: {
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        fileName: [{ required: true, message: '请上传数据' }]
      },

      fileList: [],
      headInfo: {
        token: this.$store.state.token,
        customer: this.$store.state.customer
      },

      resData: {
        success: 0,
        error: 0
      },
      resultList: [],
      projectList: []

    }
  },
  computed: {
    formatImportUrl () {
      console.log('地址', (process.env.VUE_APP_Path || '') + this.importUrl)
      return this.importUrl
    }
  },
  watch: {
    isShowImport (val) {
      this.dialogVisible = val
    }
  },
  created () {
    this.getProjectList()
  },
  methods: {
    getProjectList () {
      this.$axios.get(this.$apis.project.selectYhProjectByList).then(res => {
        this.projectList = res
      })
    },

    // 文件改变
    uploadChange (file) {
      if (this.isNeedProject) {
        this.fileList = []
        this.ruleForm.fileName = ''
        const beforeUpload = this.beforeUpload(file)
        if (beforeUpload) {
          this.fileList.push(file)
          this.ruleForm.fileName = file.name
          if (this.ruleForm.fileName) {
            this.$refs.ruleForm.clearValidate('fileName')
          }
        }
      }
    },

    // 文件上传之前
    beforeUpload (file) {
      const size = file.size / 1024 / 1024 < 10
      const type = 'xls,xlsx'
      const name = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      if (type.indexOf(name) === -1) {
        this.$message.warning('上传文件只能是 .xls,.xlsx 格式!')
        return false
      } else if (!size) {
        this.$message.warning('上传文件大小不能超过 10MB!')
        return false
      } else {
        if (!this.isNeedProject) {
          this.fullscreenLoading = true
        }
        return true
      }
    },

    // 文件上传失败
    fileError (error) {
      this.$nextTick(() => {
        this.fileList = []
        this.ruleForm.fileName = ''
      })
      this.fullscreenLoading = false
      this.$message.error(JSON.parse(error.message).message)
    },

    // 文件上传成功
    successFile (res) {
      this.fullscreenLoading = false
      if (res.data) {
        this.isShowForm = false
        this.title = '导入结果'
        if (res.data.error === 0) {
          this.closeDialog()
          this.$emit('onSuccess')
          this.$message.success('已成功导入' + res.data.success + '条，失败0条')
        } else {
          this.resData = {
            error: res.data.error || 0,
            success: res.data.success || 0
          }
          this.$emit('onSuccess')
          this.resultList = res.data.list || []
        }
      } else {
        this.$message.error(res.message)
      }
    },

    // 取消
    closeDialog () {
      this.title = '导入'
      this.$emit('update:isShowImport', false)
      this.isShowForm = true
      this.ruleForm = {
        projectId: null,
        fileName: null
      }
      this.$nextTick(() => {
        this.resultList = []
        this.resData = {
          success: 0,
          error: 0
        }
        this.$refs.ruleForm.resetFields()
      })
    },

    // 接口参数
    getParam () {
      return this.isNeedProject ? { projectId: this.ruleForm.projectId } : {}
    },

    // 保存
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true
          this.$refs.upload.submit()
        }
      })
    }

  }

}
</script>
<style scoped lang='scss'>
  .warning {

    margin-left: 32px;
    margin-bottom: 40px;

    i {
      font-size: 16px;
      color: #5750EB;
    }

    span {
      margin-left: 10px;
      font-size: 14px;
      color: #999999;
    }
  }
  .fileName {
    display: flex;
    align-items: center;
    .downloadText{
      font-size: 14px;
      color: #5750EB;
    }
    .uploading{
      font-size: 14px;
      margin-left: 20px;
    }
  }
  .resultText{
    margin-bottom: 20px;
    font-size: 14px;
    color: #5750EB;
  }

</style>
